// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1053":"986e6ce5","5771":"986e6ce5","6102":"2915d65e","6185":"dabb8755","8767":"986e6ce5"}[chunkId] + ".chunk.css";
};